import { useEffect } from "react";
import { useNotificationStore } from "@/shared/stores/notificationStore";
import type { Toast } from "@/shared/stores/notificationStore";
import styles from "./ToastContainer.module.css";

function ToastItem({ toast }: { toast: Toast }) {
  const removeToast = useNotificationStore((s) => s.removeToast);

  useEffect(() => {
    if (!toast.duration || toast.duration === 0) return;
    const timer = setTimeout(() => removeToast(toast.id), toast.duration);
    return () => clearTimeout(timer);
  }, [toast.id, toast.duration, removeToast]);

  return (
    <div className={`${styles.toast} ${styles[toast.type]}`} role="alert">
      <div className={styles.toastContent}>
        <strong className={styles.toastTitle}>{toast.title}</strong>
        {toast.message && <p className={styles.toastMessage}>{toast.message}</p>}
      </div>
      <button
        className={styles.closeBtn}
        onClick={() => removeToast(toast.id)}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
}

export function ToastContainer() {
  const toasts = useNotificationStore((s) => s.toasts);

  if (!toasts.length) return null;

  return (
    <div
      className={styles.container}
      aria-live="polite"
      data-testid="admin-toast-container"
    >
      {toasts.map((t) => (
        <ToastItem key={t.id} toast={t} />
      ))}
    </div>
  );
}
